import { apiFetcher } from '@/config/api-fetcher.config';
import type {
  GetTranslationResponse,
  TranslationGetRequestBody,
} from '@/server/api/rest/translation/translation-types';
import {
  isJsonApiSuccessResponse,
  type JsonApiResponse,
} from '@httpx/json-api';

export const fetchTranslation = async ({
  model,
  foreignKey,
  locale,
  fields,
}: TranslationGetRequestBody) => {
  return apiFetcher<JsonApiResponse<GetTranslationResponse>>(
    `/api/rest/translation?${new URLSearchParams({
      model,
      foreignKey,
      locale,
      fields,
    })}`
  ).then((resp) => {
    if (!isJsonApiSuccessResponse(resp)) {
      throw new Error(
        // @todo improve error reporting
        `Failed to update sidebar state: ${JSON.stringify(resp?.errors ?? '')}`
      );
    }
    return resp.data;
  });
};
